import BrandLogo from "@/components/common/BrandLogo";
import { BrandPanel } from "@/features/auth/components/BrandPanel";
import LoginForm from "@/features/auth/components/LoginForm";

export default function UnauthenticatedApp() {
  // min-h rather than h: a short landscape screen has to be able to scroll.
  return (
    <div className="flex min-h-screen bg-background">
      <BrandPanel />

      <div className="flex min-h-screen flex-1 flex-col items-center justify-center gap-8 px-5 py-10 sm:px-10 xl:px-16">
        {/* BrandLogo sets display inline, so the breakpoint has to live on a wrapper. */}
        <div className="lg:hidden">
          <BrandLogo iconSize={48} textWidth={170} gap={0} />
        </div>

        <LoginForm />
      </div>
    </div>
  );
}
